import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { ApiClient } from '../api'
import type { LibraryFunctionBody } from '../types'

// Core NYMR Functions library — the admin-managed catalogue of delivery
// functions pulled into forecast teams. Mirrors useRoles / useLibraryComponents.

export function useLibraryFunctions() {
  const qc = useQueryClient()
  const q = useQuery({ queryKey: ['library-functions'], queryFn: ApiClient.libraryFunctions, staleTime: 5 * 60 * 1000 })
  const invalidate = () => qc.invalidateQueries({ queryKey: ['library-functions'] })

  const create = useMutation({ mutationFn: (body: LibraryFunctionBody) => ApiClient.createLibraryFunction(body), onSuccess: invalidate })
  const patch = useMutation({ mutationFn: ({ id, body }: { id: number; body: Partial<LibraryFunctionBody> }) => ApiClient.patchLibraryFunction(id, body), onSuccess: invalidate })
  const remove = useMutation({ mutationFn: (id: number) => ApiClient.deleteLibraryFunction(id), onSuccess: invalidate })

  return {
    functions: q.data ?? [],
    isLoading: q.isLoading,
    create: (body: LibraryFunctionBody) => create.mutateAsync(body),
    patch: (id: number, body: Partial<LibraryFunctionBody>) => patch.mutateAsync({ id, body }),
    remove: (id: number) => remove.mutateAsync(id)
  }
}
